(ns frontend.view.nev.counterparty-diligence.company
  (:require
   [frontend.page-components.default-page-layout :as default-page-layout]
   [frontend.routing :as routing]
   [frontend.state.current-session :as session]
   [frontend.view.not-found :as not-found]
   [ui.view.nev.view :as nev-2024]))

(defn view
  [{:keys [entity-id entity-type]}]
  [nev-2024/view-with-data-fetching
   {:entity-id   entity-id
    :entity-type entity-type
    :state-path  [:nev-2024 entity-id]}])

(defmethod routing/render-view :entity.type/company-counterparty-diligence
  [{:keys [route-params]}]
  (let [entity-id (-> route-params
                      :id
                      js/parseInt)]
    (if-not (session/counterparty-diligence-admin?)
      [not-found/not-found-view]
      [default-page-layout/view
       ;;the key change forces rerendering of the component (and its child components)
       ^{:key (str "cpdd-company-viewer-id-" entity-id)}
       [view {:entity-id   entity-id
              :entity-type :entity.type/company-counterparty-diligence}]])))
